"use client";

import React, { useMemo, useState } from "react";
import { Button } from "reactstrap";

import { otherBlogs } from "@/utils/content";
import { ArticleType } from "@/@types/BlogArticle";
import OtherBlogsList from "./other-blogs-list";

type OtherBlogsProps = {
  articles: ArticleType[];
  searchTerm: string;
  classes: any;
};

const OtherBlogs = ({ articles, searchTerm, classes }: OtherBlogsProps) => {
  const content = otherBlogs.en;
  const [numberOfArticles, setNumberOfArticles] = useState(8);

  const moreArticles = () => {
    setNumberOfArticles((n) => n + 4);
  };

  const articlesToDisplay = useMemo(() => {
    // setNumberOfArticles(8);
    if (searchTerm)
      return articles.filter((article) =>
        article.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    else return articles;
  }, [articles, searchTerm]);

  return (
    <section className="my-5 container">
      <h3 className={classes.h3}>
        {!searchTerm ? content.title : `${content.searchFor}: ${searchTerm}`}
      </h3>
      <OtherBlogsList
        classes={classes}
        moreArticles={moreArticles}
        searchTerm={searchTerm}
        numberOfArticles={numberOfArticles}
        articlesToDisplay={articlesToDisplay}
      />
      {!searchTerm && (
        <Button
          className={classes.loadmoreBtn}
          onClick={moreArticles}
          disabled={numberOfArticles >= articlesToDisplay.length}
        >
          {otherBlogs.en.viewMore}
        </Button>
      )}
    </section>
  );
};

export default OtherBlogs;
